import {Injectable} from '@angular/core';
import {IoService} from './io.service';
import {Product} from '../models';

@Injectable()
export class ProductService extends IoService {
  protected model = Product;
  protected listUrl = '/products/';
}
